import { AuthService } from './../../services/auth/auth.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { faUser, faBars, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { PendenciasService } from 'src/app/services/pendencias.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {  

  faExclamationCircle = faExclamationCircle;
  faUser = faUser;  

  isPendencia: Boolean;

  pendenciaSubscribe: Subscription;

  isUserPlanEscritorio: boolean;

  constructor(
    private authS: AuthService,
    private pendenciaS: PendenciasService
  ) {    
    this.isUserPlanEscritorio = this.authS.isUserPlanEscritorio;
  }

  ngOnInit(): void {
    // chama o checar pendências assim que carregar a página
    if (this.logado && !this.isUserPlanEscritorio) this.checaPendencia();
  }

  /**
   * Verifica se o usuário está logado
   * @returns 
   */
  get logado(): boolean{    
    return this.authS.isLoggedIn;
  }

  /**
   * Chama o serviço para afzer o logout
   */
  logout(): void {
    this.unsubscribe();
    this.authS.SignOut();
  }

  /**
   * Chama o serviço para checar se há alguma pendência na fila
   * e exibir como uma icone de notificação
   */
  checaPendencia(): void{
    this.pendenciaSubscribe = this.pendenciaS.checaFilaPendencia.subscribe(
      (pendencia) =>{        
        this.isPendencia = pendencia;
      }
    )
  }

  // Destroi o subscribe pois ele fica no stream no firebase
  ngOnDestroy(): void {
    this.unsubscribe();
  }

  unsubscribe(): void{
    if (this.pendenciaSubscribe) this.pendenciaSubscribe.unsubscribe();
  }
}
